import { LeafLetMapOptions, LeafletMap, LeafletMapTiles } from "../modules";
import { AbstractComponent } from "./AbstractComponent";

export interface PopoverMapProps extends LeafLetMapOptions {
  popover: HTMLElement;
}

export class PopoverMap extends AbstractComponent<PopoverMapProps> {
  public render(): void {
    this.createContext();
    const map = LeafletMap.create(
      this.el as HTMLDivElement,
      {
        center: this.props.center,
        zoom: this.props.zoom,
        tiles: this.props.tiles,
        markers: this.props.markers
      }
    );
    map.markers();
  }
  
  protected createContext(): void {
    const { popover } = this.props;
    const popoverBody = document.createElement('div');
    popoverBody.classList.add('popover-body');
    popover.appendChild(popoverBody);
    this.el.classList.add('venue-map');
    popoverBody.appendChild(this.el);
  }


  public static create(options: object, popover: HTMLElement) {
    try {
      const props: PopoverMapProps = {
        ...this.optionsFrom(options),
        popover
      };
      return new PopoverMap(props);
    } catch {
      throw new Error('ERROR_PARSING_MAP_OPTIONS')
    }
  }

  private static optionsFrom(options: object): LeafLetMapOptions {
    const center = options["map-center"] 
      ? options["map-center"] .split(',').map((coord) => parseFloat(coord))
      : [0, 0];
    const zoom = options["map-zoom"] ? parseInt(options["map-zoom"]) : 13;
    const tiles = options["map-tiles"] ? options["map-tiles"] : LeafletMapTiles.TONER;
    const markers = options["map-markers"] 
      ? options["map-markers"].map((marker) => ({
        ...marker,
        position: marker.position.split(',').map((coord) => parseFloat(coord))
      }))
      : [];
    return { 
      center: center as LeafLetMapOptions["center"], 
      zoom: zoom as LeafLetMapOptions["zoom"],
      tiles: tiles as LeafLetMapOptions["tiles"],
      markers: markers as LeafLetMapOptions["markers"]
    };
  }

}